import { IOrder } from "records/order";
import { MomentInput } from "moment";

export interface OrderedLineItem {
    _id: string;
    prebook: boolean;
    ship_start: MomentInput;
    ship_end: MomentInput;
    quantities: { [sizeName: string]: number };
    notes: string;
    [attribute: string]: any;
}

type OrderedQuantities = { [productId: string]: { [warehouseId: string]: OrderedLineItem[] } };

export interface ICart {
    result: string;
    items: Set<string>;
    entities: {
        [key: string]: IOrder | { [id: string]: IOrder };
    };
    orderedQuantities?: OrderedQuantities;
    isBulkOrder: boolean;
}

export const WORKING_ORDER_SNACKBAR_ID = "WORKING_ORDER_SNACKBAR";
export const WORKING_ORDER_UPDATE_ACTION = "working-order-update";
export const SHIPMENT_QUANTITY_MODAL = "shipment-quantity-modal";
export const MANAGE_DELIVERIES_MODAL = "manage-deliveries-modal";
export const DELIVERY_MANAGEMENT_ACTION_RESULT = "delivery-management-action-result";
export const EDIT_DELIVERY_MODAL = "edit-delivery-modal";
export const DELETE_DELIVERY = "delete-delivery";
export const VIEW_INVENTORY = "view-inventory";
export const DUPLICATE_LOCATIONS_MODAL = "duplicate-locations-modal";
export const BUILD_ORDER = "open-build-order";
export const CART_CONFIRMATION_MODAL = "cart-confirmation-modal";
export const EXCEEDED_QUANTITIES_MODAL = "exceeded-quantities-modal";
export const PROCESS_EXCEEDED_QUANTITIES = "process-exceeded-quantities";
export const SAVE_SIZING_VIEW_MODAL = "save-sizing-view-modal";
export const SHIPMENT_REVIEW_IFRAME_MESSAGE = "shipment-review-iframe-message";
export const POST_TO_IFRAME = "post-to-iframe";
export const SAVE_CUSTOM_GRID_VIEW = "save-custom-grid-view";
export const EXCEEDED_CUSTOMIZATION_MODAL = "exceeded-customization-modal";
export const GRID_VIEW_NOTIFICATION = {
    REMOVE: "grid-view-notification-remove",
    DISMISS: "grid-view-notification-dismiss",
    UPDATE: "cart-notifications-update",
};
export const AUTO_REDUCE = "auto-reduce";
export const REVIEW_MANUALLY = "no-reduce";
export const IFRAME_REDUX_ACTION = "iframe-redux-action";

export enum WORKING_ORDER_UPDATE_TYPE {
    SIZE_UPDATE = "update-size-quantity",
    SIZE_ADD = "add-size-quantity",
    LINE_ITEM_UPDATE = "update-line-item",
    LINE_ITEM_ADD = "add-line-item",
    LINE_ITEM_CREATE = "add-line-create",
    LINE_ITEM_REMOVE = "remove-line-item",
    PRODUCT_REMOVE = "remove-product",
}

export const BULK_UNITS_SIZE = "_bulk";
